import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dataNaoPodeSerPassadaValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        const dataInicio = new Date(control.value);
        dataInicio.setHours(0, 0, 0, 0);

        return dataInicio < hoje ? { dataPassada: true } : null;
    };
}

export function dataTerminoMaiorQueInicioValidator() {
    return (group: AbstractControl): ValidationErrors | null => {
        const inicio = group.get('DataInicioRecompensa')?.value;
        const termino = group.get('DataTerminoRecompensa')?.value;

        if (!inicio || !termino) return null;

        const dataInicio = new Date(inicio);
        const dataTermino = new Date(termino);

        return dataTermino <= dataInicio
            ? { dataTerminoInvalida: true }
            : null;
    };
}

